
require('./bootstrap');

window.Vue = require('vue');
window.moment = require('moment');
window.events = new Vue();

import excel from "vue-excel-export";

import vSelect from "vue-select";

import VueSweetalert2 from 'vue-sweetalert2';
import 'moment/locale/pt-br';
import './components/util/Cpf.js';
import './components/util/Cnpj.js';
import './components/util/Email.js';
import './components/util/MomentFormat.js';
import store from './store/store.js';
import VueCookies from 'vue-cookies';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import VueTheMask from 'vue-the-mask';

// Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/pt-br'

// Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.config.debug = true;
Vue.config.silent = false;
Vue.use(datePicker);
Vue.use(VueSweetalert2);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueCookies, { expires: '7d'})
Vue.use(VueTheMask);
Vue.use(ElementUI, { locale });
Vue.use(excel);

Vue.component('datepicker', require('vuejs-datepicker'));
Vue.component('vHomeAdmClear', require('./components/util/HomeAdmClear.vue'));
Vue.component('vTable', require('./components/util/Table.vue'));
Vue.component('vTag', require('./components/util/Tag.vue'));
Vue.component('vPassword', require('./components/util/Password.vue'));
Vue.component('v-spc-consulta-index', require('./components/adm_spc/Index.vue'));
Vue.component('vAvatar', require('./components/util/Avatar.vue'));
Vue.component('vAutocomplete', require('./components/util/Autocomplete.vue'));
Vue.component('vTransportadora', require('./components/util/TrackingTransportadora.vue'));

/**Distribuidor */
Vue.component('v-distribuidor-index', require('./components/distribuidor/Index.vue'));
Vue.component('v-distribuidor-show', require('./components/distribuidor/Show.vue'));

Vue.component('distribuidorCustomLogin', require('./components/distribuidor/Home/CustomLoginPage.vue'));
Vue.component('lote', require('./components/lote/Lote.vue'));

// Configuracao
Vue.component('v-user-index', require('./components/User/Index.vue'));
Vue.component('v-banner-index', require('./components/_internal/configuracoes/banner/Index.vue'));
Vue.component('v-notificacao-index', require('./components/_internal/configuracoes/notificacao/Index.vue'));
Vue.component('v-popup-index', require('./components/_internal/configuracoes/popup/Index.vue'));

Vue.component('vMaterialDownload', require('./components/material_download/Main.vue'));
Vue.component('vHomeDistribuidor', require('./components/HomeDistribuidor.vue'));
Vue.component('vRevendedora', require('./components/revendedora/Main.vue'));
Vue.component('vPdv', require('./components/pdv/Main.vue'));
Vue.component('vProdutos', require('./components/produtos/Main.vue'));
Vue.component('AdmProdutoEstoque', require('./components/produtos/AdmEstoque.vue'));
Vue.component('vPedidosIndex', require('./components/pedidos/Main.vue'));
Vue.component('vCreatePedido', require('./components/pedidos/create/Main.vue'));
Vue.component('vEstoque', require('./components/estoque/Main.vue'));
Vue.component('vEstoqueImprimir', require('./components/estoque/Imprimir.vue'));
Vue.component('vPedidoMinimo', require('./components/pedido_minimo/Main.vue'));
Vue.component('vLote', require('./components/lote/List.vue'));
Vue.component('vRankingProdutos', require('./components/distribuidor_ranking/Produtos.vue'));
Vue.component('vRankingEstoque', require('./components/distribuidor_ranking/Estoque.vue'));
Vue.component('vRankingRevendedora', require('./components/distribuidor_ranking/Revendedora.vue'));
Vue.component('v-treinamentos', require('./components/treinamentos/Main.vue'));
Vue.component('vAdmCampanhas', require('./components/adm_campanha/Main.vue'));
Vue.component('vAdmBoletos', require('./components/adm_boleto/Main.vue'));
Vue.component('vAdmListPedidos', require('./components/adm_pedidos/Main.vue'));
// Vue.component('vAdmRevendedorasIndicadas', require('./components/adm_revendedoras_indicadas/Main.vue'));
// Vue.component('vRevendedorasIndicadas', require('./components/revendedoras_indicadas/Main.vue'));
Vue.component('vBoletos', require('./components/boleto/Main.vue'));
Vue.component('vBoletosAntigos', require('./components/boleto/antigos.vue'));

Vue.component("v-prospect-index", require("./components/adm_prospecto/Index.vue"));
Vue.component("v-prospect-create", require("./components/adm_prospecto/Create.vue"));
Vue.component("v-prospect-edit", require("./components/adm_prospecto/Edit.vue"));
Vue.component("v-prospect-show", require("./components/adm_prospecto/Show.vue"));

Vue.component('vDistribuidorImportarPedidos', require('./components/distribuidor_importar_pedidos/Main.vue'));
Vue.component('vListaMetas', require('./components/adm_metas/List.vue'));
Vue.component('vGraphMetas', require('./components/adm_metas/Metas.vue'));
Vue.component('vDevolucao', require('./components/distribuidor/devolucao/Create.vue'));
Vue.component('vListaDevolucao', require('./components/distribuidor/devolucao/List.vue'));
Vue.component('vDevolucaoAdm', require('./components/adm_devolucao/List.vue'));
Vue.component('vMigraRevendedora', require('./components/adm_migracao/List.vue'));
Vue.component('vLiberaMigracao', require('./components/adm_migracao/Liberacao.vue'));
Vue.component('ListaTransportadora', require('./components/transportadora/List.vue'));
Vue.component('vRelatorioPedidos', require('./components/distribuidor/relatorio/Pedidos.vue'));
Vue.component('vIntegraSite', require('./components/adm_lead/index.vue'));
Vue.component('vMapa', require('./components/rotas/Rotas.vue'));
Vue.component('vRotaParametro', require('./components/rotas/Parametros.vue'));
Vue.component('vListRotas', require('./components/rotas/ListRotas.vue'));
Vue.component('vEditRotas', require('./components/rotas/EditRota.vue'));
Vue.component('vDiarioRota', require('./components/rotas/Diario.vue'));
Vue.component('vListDespesas', require('./components/rotas/adm/List.vue'));
Vue.component('vListBonificado', require('./components/pedidos/Bonificados.vue'));
Vue.component('vRelatorioPdv', require('./components/distribuidor/relatorio/PDV.vue'));
Vue.component('vRelatorioFalha', require('./components/distribuidor/relatorio/Falha.vue'));
Vue.component('vDescontos', require('./components/adm_prohotel/List.vue'));
Vue.component('AdmProduto', require('./components/produtos/AdmProdutos.vue'));
Vue.component('comissoes-excel', require('./components/adm_comissoes/Excel.vue'));
Vue.component('comissoes-cd', require('./components/distribuidor/relatorio/TabelaComissoes'));
Vue.component('numero-whatsapp', require('./components/util/numero-whatsapp'));
Vue.component('kit-personalizado', require('./components/util/KitPersonalizado'));
Vue.component('agenda-distribuidor', require('./components/adm_agenda/index.vue'));
Vue.component('vCalendario', require('./components/util/Calendario.vue'));
Vue.component('vGetCampanha', require('./components/util/getCampanha.vue'));
Vue.component('vPermission', require('./components/util/Permissoes.vue'));

Vue.component('v-etiqueta-index', require('./components/distribuidor/EtiquetaIndex.vue'));
Vue.component('etiquetas', require('./components/distribuidor/Etiquetas.vue'));

// Atendimentos
Vue.component('vListaAtendimento', require('./components/atendimento/List.vue'));
Vue.component('vAtendimento', require('./components/atendimento/Sidebar.vue'));
Vue.component('vAtendimentoMensagens', require('./components/atendimento/Mensagens.vue'));

/* COMPONENTES DO VAREJO */
Vue.component('produtos-varejo', require('./components/varejo/produtos/index.vue'));
Vue.component('lista-proposta', require('./components/varejo/propostas/lista.vue'));
Vue.component('proposta-venda-direta', require('./components/varejo/propostas/create-proposta.vue'));
Vue.component('descontos-venda-direta', require('./components/varejo/produtos/descontos.vue'));
Vue.component('pedidos-venda-direta', require('./components/varejo/pedidos/index.vue'));
Vue.component('clientes-venda-direta', require('./components/varejo/distribuidores/index.vue'));

// Comunicados
Vue.component('vHomeComunicado', require('./components/util/HomeComunicado.vue'));

/* INDIQUE GANHE */
Vue.component('indique-ganhe', require('./components/indique-ganhe/config.vue'));

/* CONFIGURACOES CENTRO DISTRIBUICAO */
Vue.component('centro-distribuicao', require('./components/centro_distribuicao/index.vue'));

/* RELATORIOS */
Vue.component('relatorio-prospecto', require('./components/relatorios/prospectos.vue'));
Vue.component('vRelatorioVarejo', require('./components/relatorios/componentes/relatorio-varejo.vue'));
Vue.component('vRelatorioItemVarejo', require('./components/relatorios/componentes/relatorio-item-varejo.vue'));

// Materiais Divulgacao
Vue.component('vMaterialDivulgacao', require('./components/material_divulgacao/Main.vue'));
Vue.component('vListaMaterialDivulgacao', require('./components/material_divulgacao/List.vue'));

// Ocorrencias
Vue.component('vListaOcorrencia', require('./components/ocorrencia/List.vue'));
Vue.component('vOcorrencia', require('./components/ocorrencia/Edit.vue'));
Vue.component('vMensagens', require('./components/ocorrencia/componente/Mensagens.vue'));
Vue.component('vMensagem', require('./components/ocorrencia/componente/Mensagem.vue'));
Vue.component('vMensagensBar', require('./components/ocorrencia/componente/MensagensBar.vue'));

// indicados
Vue.component('vAdmIndicados', require('./components/indicados/Index.vue'));
Vue.component('vAdmRevendedorasIndicadas', require('./components/indicados/revendedoras_indicadas/Main.vue'));
Vue.component('vAdmDistribuidoresIndicados', require('./components/indicados/distribuidores_indicados/Index.vue'));

// Operação Catalogo
Vue.component('vOperacaoCatalogo', require('./components/distribuidor/Home/OperacaoCatalogo.vue'));
Vue.component('vAdmOperacaoCatalogo', require('./components/adm_operacao_catalogo/Index.vue'));

// Retenção de distribuidores
Vue.component('vAdmRetencao', require('./components/adm_retencao/Index.vue'));
Vue.component('vAdmRetencaoMetas', require('./components/adm_retencao/Metas.vue'));

// Atualizacao de Cadastro
Vue.component('vAtualiza', require('./components/distribuidor/Home/atualizacao.vue'));

// Reset Password
Vue.component('v-reset-password', require('./components/util/ResetPassword.vue'));
Vue.component('v-remember-password', require('./components/util/Remember.vue'));
Vue.component('v-remember-reset', require('./components/util/RememberReset.vue'));

// select de buscar distribuidor
Vue.component('VBuscaDistribuidor', require('./components/util/BuscaDistribuidor.vue'));

// Power BI
Vue.component('VBi', require('./components/adm_bi/Main.vue'));

// Prazos de Pagamento
Vue.component('vAdmListPrazos', require('./components/adm_prazos/Index.vue'));

// Agenda Adm
Vue.component('vAgenda', require('./components/agenda/Index.vue')); 
Vue.component('vAgendaParametro', require('./components/agenda/ListParametros.vue'));
Vue.component('vVerticalNavbar', require('./components/adm_vertical_navbar/Main.vue'));
Vue.component('v-navbar-create', require('./components/adm_vertical_navbar/create.vue'));
Vue.component('vHorizontalNavbar', require('./components/adm_horizontal_navbar/Main.vue'));
Vue.component('vExtratoFinanceiro', require('./components/distribuidor/relatorio/ExtratoFinanceiro.vue'));
Vue.component('vDevolucaoAdmList', require('./components/adm_devolucao/DevolucaoAdm.vue'));
Vue.component("v-select", vSelect);

// home distribuidor
Vue.component('vHomeUser', require('../js/components/util/UserHome.vue'));
Vue.component('vCarouselHome', require('../js/components/util/CarouselHome.vue'));
Vue.component('vPodioHome', require('../js/components/distribuidor/Home/PodioHome.vue'));
Vue.component('vNivelHome', require('../js/components/distribuidor/Home/NivelHome.vue'));
Vue.component('vIncentivosHome', require('../js/components/distribuidor/Home/IncentivosHome.vue'));

/* BOTÕES DO COMPONENTE DATEPICKER */
jQuery.extend(true, jQuery.fn.datetimepickers, {
  icons: {
    time: 'far fa-clock',
    date: 'far fa-calendar',
    up: 'fas fa-arrow-up',
    down: 'fas fa-arrow-down',
    previous: 'fas fa-chevron-left',
    next: 'fas fa-chevron-right',
    today: 'fas fa-calendar-check',
    clear: 'far fa-trash-alt',
    close: 'far fa-times-circle'
  }
});

const app = new Vue({
  store,
  el: '#app',
});




// WEBPACK FOOTER //
// ./resources/assets/js/app.js